<template>
    <div class="web-agent-tab">
        <div class="web-agent-tab-layout">
            <!-- Ayarlar yoksa Bilgilendirme ve oluşturma butonu göster -->
            <div v-if="!webAgentSettings" class="no-settings-container">
                <div class="info-panel">
                    <h3>{{ $t("voiceagent.webVoiceAgentTitle") }}</h3>
                    <p>
                        {{ $t("voiceagent.webAgentIntro") }}
                    </p>

                    <div class="features">
                        <h4>{{ $t("voiceagent.webAgentFeaturesTitle") }}</h4>
                        <ul>
                            <li>
                                <i class="material-icons">check_circle</i> {{ $t("voiceagent.webAgentFeatureVoice") }}
                            </li>
                            <li><i class="material-icons">check_circle</i> {{ $t("voiceagent.webAgentFeatureLanguages") }}</li>
                            <li>
                                <i class="material-icons">check_circle</i> {{ $t("voiceagent.webAgentFeatureAppearance") }}
                            </li>
                            <li>
                                <i class="material-icons">check_circle</i> {{ $t("voiceagent.webAgentFeaturePageFilter") }}
                            </li>
                            <li><i class="material-icons">check_circle</i> {{ $t("voiceagent.webAgentFeatureDomain") }}</li>
                        </ul>
                    </div>

                    <PermissionController :permissions="['voice-agent.create']">
                        <supsis-button primary @click="createWebAgent">
                            <i class="material-icons">add</i> {{ $t("voiceagent.createWebVoiceAgent") }}
                        </supsis-button>
                    </PermissionController>
                </div>
            </div>

            <!-- Ayarlar varsa, ayar formunu göster -->
            <div v-else class="settings-container">
                <div class="settings-layout">
                    <!-- Sol taraf: Form -->
                    <div class="settings-form">
                        <a-form layout="vertical" :form="form">
                            <!-- Genel Ayarlar Bölümü -->
                            <div class="settings-section">
                                <div
                                    class="section-header"
                                    @click="toggleSection('general')"
                                    :class="{ open: isSectionOpen('general') }"
                                >
                                    <div class="section-title">
                                        <i class="material-icons">settings</i>
                                        <h3>{{ $t("voiceagent.generalSettings") }}</h3>
                                    </div>
                                    <i class="material-icons toggle-icon">{{
                                        isSectionOpen("general") ? "keyboard_arrow_up" : "keyboard_arrow_down"
                                    }}</i>
                                </div>
                                <div class="section-content" v-show="isSectionOpen('general')">
                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item :label="$t('voiceagent.statusLabel')">
                                                <a-switch
                                                    v-model="formData.enabled"
                                                    :checked-children="$t('voiceagent.switchActive')"
                                                    :un-checked-children="$t('voiceagent.switchInactive')"
                                                />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item :label="$t('voiceagent.placement')">
                                                <a-select v-model="formData.position">
                                                    <a-select-option value="bottom-right">{{ $t("voiceagent.positionBottomRight") }}</a-select-option>
                                                    <a-select-option value="bottom-left">{{ $t("voiceagent.positionBottomLeft") }}</a-select-option>
                                                    <a-select-option value="bottom-middle">{{ $t("voiceagent.positionBottomMiddle") }}</a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>

                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item :label="$t('voiceagent.buttonText')">
                                                <a-input v-model="formData.buttonText" :placeholder="$t('voiceagent.voiceChat')" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item :label="$t('voiceagent.customIconType')">
                                                <a-select v-model="formData.icon">
                                                    <a-select-option value="phone">{{ $t("voiceagent.iconTypePhone") }}</a-select-option>
                                                    <a-select-option value="avatar">{{ $t("voiceagent.iconTypeAvatar") }}</a-select-option>
                                                    <a-select-option value="custom">{{ $t("voiceagent.iconTypeCustom") }}</a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>

                                    <!-- Offset Ayarları Bölümü -->
                                    <a-row :gutter="16">
                                        <a-col :span="24">
                                            <h4>{{ $t("voiceagent.edgeOffsets") }}</h4>
                                        </a-col>
                                        <a-col :span="6">
                                            <a-form-item :label="$t('voiceagent.fromOffset')">
                                                <a-input-number
                                                    v-model="formData.offsetTop"
                                                    :min="0"
                                                    :max="500"
                                                    style="width: 100%"
                                                />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="6">
                                            <a-form-item :label="$t('voiceagent.bottomOffset')">
                                                <a-input-number
                                                    v-model="formData.offsetBottom"
                                                    :min="0"
                                                    :max="500"
                                                    style="width: 100%"
                                                />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="6">
                                            <a-form-item :label="$t('voiceagent.rightOffset')">
                                                <a-input-number
                                                    v-model="formData.offsetRight"
                                                    :min="0"
                                                    :max="500"
                                                    style="width: 100%"
                                                />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="6">
                                            <a-form-item :label="$t('voiceagent.leftOffset')">
                                                <a-input-number
                                                    v-model="formData.offsetLeft"
                                                    :min="0"
                                                    :max="500"
                                                    style="width: 100%"
                                                />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>

                                    <!-- Custom İkon Yükleme (sadece custom seçilince) -->
                                    <a-row v-if="formData.icon === 'custom'">
                                        <a-col :span="24">
                                            <a-form-item :label="$t('voiceagent.customIcon')">
                                                <p>{{ $t("voiceagent.customIconComingSoon") }}</p>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>

                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item :label="$t('voiceagent.hidePoweredByLabel')">
                                                <a-switch v-model="formData.hidePoweredByText" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item :label="$t('voiceagent.optOutStorageHelp')">
                                                <a-switch
                                                    v-model="formData.optOutSensitiveDataStorage"
                                                    :checked-children="$t('voiceagent.switchYes')"
                                                    :un-checked-children="$t('voiceagent.switchNo')"
                                                />
                                                <div class="help-text">
                                                    {{ $t("voiceagent.optOutStorageDescription") }}
                                                </div>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </div>
                            </div>

                            <!-- Renk Ayarları Bölümü -->
                            <div class="settings-section">
                                <div
                                    class="section-header"
                                    @click="toggleSection('colors')"
                                    :class="{ open: isSectionOpen('colors') }"
                                >
                                    <div class="section-title">
                                        <i class="material-icons">palette</i>
                                        <h3>{{ $t("voiceagent.lookSettings") }}</h3>
                                    </div>
                                    <i class="material-icons toggle-icon">{{
                                        isSectionOpen("colors") ? "keyboard_arrow_up" : "keyboard_arrow_down"
                                    }}</i>
                                </div>
                                <div class="section-content" v-show="isSectionOpen('colors')">
                                    <a-row :gutter="16">
                                        <a-col :span="8">
                                            <a-form-item :label="$t('voiceagent.primaryColor')">
                                                <color-picker-item
                                                    :title="$t('voiceagent.primaryColor')"
                                                    v-model="formData.colors.primaryColor"
                                                    :rawColor="formData.colors.primaryColor"
                                                />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="8">
                                            <a-form-item :label="$t('voiceagent.textColorLabel')">
                                                <color-picker-item
                                                    :title="$t('voiceagent.textColorLabel')"
                                                    v-model="formData.colors.textColor"
                                                    :rawColor="formData.colors.textColor"
                                                />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="8">
                                            <a-form-item :label="$t('voiceagent.backgroundColorLabel')">
                                                <color-picker-item
                                                    :title="$t('voiceagent.backgroundColorLabel')"
                                                    v-model="formData.colors.backgroundColor"
                                                    :rawColor="formData.colors.backgroundColor"
                                                />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>

                                    <a-divider orientation="left">{{ $t("voiceagent.advancedColorSettings") }}</a-divider>
                                    <p>
                                        <a @click="showAdvancedColors = !showAdvancedColors" style="cursor: pointer">
                                            <a-icon :type="showAdvancedColors ? 'up' : 'down'" />
                                            {{
                                                showAdvancedColors
                                                    ? $t("voiceagent.hideAdvancedColors")
                                                    : $t("voiceagent.showAdvancedColors")
                                            }}
                                        </a>
                                    </p>

                                    <div v-if="showAdvancedColors">
                                        <h4>{{ $t("voiceagent.buttonColors") }}</h4>
                                        <a-row :gutter="16">
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.buttonBackground')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.buttonBackground')"
                                                        v-model="formData.colors.buttonBackgroundColor"
                                                        :rawColor="formData.colors.buttonBackgroundColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.buttonTextColor')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.buttonTextColor')"
                                                        v-model="formData.colors.buttonTextColor"
                                                        :rawColor="formData.colors.buttonTextColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.buttonHoverColor')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.buttonHoverColor')"
                                                        v-model="formData.colors.buttonHoverBackgroundColor"
                                                        :rawColor="formData.colors.buttonHoverBackgroundColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                        </a-row>

                                        <h4>{{ $t("voiceagent.containerColors") }}</h4>
                                        <a-row :gutter="16">
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.containerBackground')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.containerBackground')"
                                                        v-model="formData.colors.containerBackgroundColor"
                                                        :rawColor="formData.colors.containerBackgroundColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.containerBorder')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.containerBorder')"
                                                        v-model="formData.colors.containerBorderColor"
                                                        :rawColor="formData.colors.containerBorderColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                        </a-row>

                                        <h4>{{ $t("voiceagent.iconColors") }}</h4>
                                        <a-row :gutter="16">
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.iconBackground')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.iconBackground')"
                                                        v-model="formData.colors.iconBackgroundColor"
                                                        :rawColor="formData.colors.iconBackgroundColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.iconBorder')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.iconBorder')"
                                                        v-model="formData.colors.iconBorderColor"
                                                        :rawColor="formData.colors.iconBorderColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                        </a-row>

                                        <h4>{{ $t("voiceagent.languageSelectorColors") }}</h4>
                                        <a-row :gutter="16">
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.languageSelectorBackground')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.languageSelectorBackground')"
                                                        v-model="formData.colors.languageSelectorBackgroundColor"
                                                        :rawColor="formData.colors.languageSelectorBackgroundColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.languageSelectorText')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.languageSelectorText')"
                                                        v-model="formData.colors.languageSelectorTextColor"
                                                        :rawColor="formData.colors.languageSelectorTextColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.languageSelectorBorder')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.languageSelectorBorder')"
                                                        v-model="formData.colors.languageSelectorBorderColor"
                                                        :rawColor="formData.colors.languageSelectorBorderColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                        </a-row>

                                        <h4>{{ $t("voiceagent.otherColors") }}</h4>
                                        <a-row :gutter="16">
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.poweredByTextColor')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.poweredByTextColor')"
                                                        v-model="formData.colors.poweredByTextColor"
                                                        :rawColor="formData.colors.poweredByTextColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.activeCallColor')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.activeCallColor')"
                                                        v-model="formData.colors.activeCallBorderColor"
                                                        :rawColor="formData.colors.activeCallBorderColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.connectingCallColor')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.connectingCallColor')"
                                                        v-model="formData.colors.connectingCallBorderColor"
                                                        :rawColor="formData.colors.connectingCallBorderColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                        </a-row>
                                        <a-row :gutter="16">
                                            <a-col :span="8">
                                                <a-form-item :label="$t('voiceagent.passiveCallColor')">
                                                    <color-picker-item
                                                        :title="$t('voiceagent.passiveCallColor')"
                                                        v-model="formData.colors.inactiveCallBorderColor"
                                                        :rawColor="formData.colors.inactiveCallBorderColor"
                                                    />
                                                </a-form-item>
                                            </a-col>
                                        </a-row>
                                    </div>
                                </div>
                            </div>

                            <!-- Dil Ayarları Bölümü -->
                            <div class="settings-section">
                                <div
                                    class="section-header"
                                    @click="toggleSection('language')"
                                    :class="{ open: isSectionOpen('language') }"
                                >
                                    <div class="section-title">
                                        <i class="material-icons">translate</i>
                                        <h3>{{ $t("voiceagent.languageSettings") }}</h3>
                                    </div>
                                    <i class="material-icons toggle-icon">{{
                                        isSectionOpen("language") ? "keyboard_arrow_up" : "keyboard_arrow_down"
                                    }}</i>
                                </div>
                                <div class="section-content" v-show="isSectionOpen('language')">
                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item :label="$t('voiceagent.languageSelectorShow')">
                                                <a-switch v-model="formData.showLanguageSelector" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item :label="$t('voiceagent.defaultLanguage')">
                                                <a-select
                                                    v-model="formData.defaultLanguage"
                                                    show-search
                                                    :filter-option="filterLanguageOption"
                                                >
                                                    <a-select-option
                                                        v-for="language in languageOptions"
                                                        :key="language.id"
                                                        :value="language.id"
                                                    >
                                                        {{ language.name }} ({{ language.id }})
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>

                                    <a-row v-if="formData.showLanguageSelector">
                                        <a-col :span="24">
                                            <a-form-item :label="$t('voiceagent.availableLanguages')">
                                                <a-select
                                                    mode="multiple"
                                                    v-model="formData.availableLanguages"
                                                    show-search
                                                    :filter-option="filterLanguageOption"
                                                    :placeholder="$t('voiceagent.selectLanguagesPlaceholder')"
                                                >
                                                    <a-select-option
                                                        v-for="language in languageOptions"
                                                        :key="language.id"
                                                        :value="language.id"
                                                    >
                                                        {{ language.name }} ({{ language.id }})
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </div>
                            </div>

                            <!-- Sayfa Kısıtlamaları Bölümü -->
                            <div class="settings-section">
                                <div
                                    class="section-header"
                                    @click="toggleSection('pages')"
                                    :class="{ open: isSectionOpen('pages') }"
                                >
                                    <div class="section-title">
                                        <i class="material-icons">filter_list</i>
                                        <h3>{{ $t("voiceagent.pageRestrictions") }}</h3>
                                    </div>
                                    <i class="material-icons toggle-icon">{{
                                        isSectionOpen("pages") ? "keyboard_arrow_up" : "keyboard_arrow_down"
                                    }}</i>
                                </div>
                                <div class="section-content" v-show="isSectionOpen('pages')">
                                    <a-form-item :label="$t('voiceagent.whitelistPages')">
                                        <a-select
                                            mode="tags"
                                            v-model="formData.whitelistPages"
                                            :placeholder="$t('voiceagent.whitelistPagesPlaceholder')"
                                            style="width: 100%"
                                        >
                                            <a-select-option value="*">{{ $t("voiceagent.whitelistAllPages") }}</a-select-option>
                                        </a-select>
                                        <div class="help-text">
                                            {{ $t("voiceagent.whitelistPagesHelp") }}
                                        </div>
                                    </a-form-item>

                                    <a-form-item :label="$t('voiceagent.blacklistPages')">
                                        <a-select
                                            mode="tags"
                                            v-model="formData.blacklistPages"
                                            :placeholder="$t('voiceagent.blacklistPagesPlaceholder')"
                                            style="width: 100%"
                                        >
                                        </a-select>
                                        <div class="help-text">{{ $t("voiceagent.blacklistPagesHelp") }}</div>
                                    </a-form-item>
                                </div>
                            </div>

                            <!-- Domain Kısıtlamaları Bölümü -->
                            <div class="settings-section">
                                <div
                                    class="section-header"
                                    @click="toggleSection('domains')"
                                    :class="{ open: isSectionOpen('domains') }"
                                >
                                    <div class="section-title">
                                        <i class="material-icons">domain</i>
                                        <h3>{{ $t("voiceagent.domainRestrictions") }}</h3>
                                    </div>
                                    <i class="material-icons toggle-icon">{{
                                        isSectionOpen("domains") ? "keyboard_arrow_up" : "keyboard_arrow_down"
                                    }}</i>
                                </div>
                                <div class="section-content" v-show="isSectionOpen('domains')">
                                    <a-form-item :label="$t('voiceagent.allowedDomains')">
                                        <a-select
                                            mode="tags"
                                            v-model="formData.allowedDomains"
                                            :placeholder="$t('voiceagent.allowedDomainsPlaceholder')"
                                            style="width: 100%"
                                        >
                                        </a-select>
                                        <div class="help-text">
                                            {{ $t("voiceagent.allowedDomainsHelp") }}
                                        </div>
                                    </a-form-item>
                                </div>
                            </div>

                            <!-- Yayınlama Kodu Bölümü -->
                            <div class="settings-section">
                                <div
                                    class="section-header"
                                    @click="toggleSection('code')"
                                    :class="{ open: isSectionOpen('code') }"
                                >
                                    <div class="section-title">
                                        <i class="material-icons">code</i>
                                        <h3>{{ $t("voiceagent.integrationCode") }}</h3>
                                    </div>
                                    <i class="material-icons toggle-icon">{{
                                        isSectionOpen("code") ? "keyboard_arrow_up" : "keyboard_arrow_down"
                                    }}</i>
                                </div>
                                <div class="section-content" v-show="isSectionOpen('code')">
                                    <p>
                                        {{ $t("voiceagent.bodyTagIntegrationHint") }}
                                    </p>

                                    <div class="code-block">
                                        <pre><code>&lt;script src="{{ voiceAgentUrl }}/setup.js?t={{ timestamp
                                            }}" type="text/javascript" async defer id="supsis-ai-web-voice-agent" site-id="{{ siteId
                                            }}" agent-id="{{ agent.agent_id }}"&gt;&lt;/script&gt;</code></pre>
                                        <a-button type="primary" @click="copyCode" icon="copy" class="copy-btn"
                                            >{{ $t("voiceagent.copyCode") }}
                                        </a-button>
                                    </div>
                                </div>
                            </div>

                            <!-- Kaydetme Butonları -->
                            <div class="form-actions">
                                <PermissionController :permissions="['voice-agent.update']">
                                    <a-button type="primary" @click="saveSettings" :loading="isSaving">
                                        {{ $t("voiceagent.saveSettings") }}
                                    </a-button>
                                </PermissionController>
                            </div>
                        </a-form>
                    </div>

                    <!-- Sağ taraf: Preview -->
                    <div class="settings-preview-container">
                        <div class="settings-preview">
                            <web-agent-preview :settings="formData" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VOICE_AGENT_API } from "../../../../../../../api/voiceAgent";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import ColorPickerItem from "../../../../../Settings/components/theme/ColorPickerItem.vue";
import WebAgentPreview from "../../../components/WebAgentPreview.vue";
import CONFIG from "../../.././../../../../config/config";
import _ from "lodash";

export default {
    name: "WebAgentTab",
    components: {
        SupsisButton,
        ColorPickerItem,
        WebAgentPreview,
    },
    props: {
        agent: {
            type: Object,
            required: true,
        },
    },
    computed: {
        siteId() {
            return this.$store.state?.site.site?._id;
        },
        voiceAgentUrl() {
            if (CONFIG.PRODUCTION) {
                return `https://webagent.supsis.ai`;
            } else {
                return `http://voice-agent-local.supsis.live`;
            }
        },
    },
    data() {
        return {
            webAgentSettings: null,
            isSaving: false,
            isLoading: true,
            publishCode: "",
            timestamp: Math.floor(Date.now() / 1000),

            form: this.$form.createForm(this),
            formData: {
                enabled: true,
                position: "bottom-right",
                buttonText: "Voice Chat",
                icon: "phone",
                colors: {
                    primaryColor: "#3498db",
                    textColor: "#ffffff",
                    backgroundColor: "#ffffff",
                    containerBackgroundColor: "#ffffff",
                    containerBorderColor: "#e1e1e1",
                    buttonBackgroundColor: "#000000",
                    buttonTextColor: "#ffffff",
                    buttonHoverBackgroundColor: "#333333",
                    iconBackgroundColor: "#f0f0f0",
                    iconBorderColor: "#d0d0d0",
                    languageSelectorBackgroundColor: "#ffffff",
                    languageSelectorTextColor: "#333333",
                    languageSelectorBorderColor: "rgba(0, 0, 0, 0.1)",
                    poweredByTextColor: "rgba(0, 0, 0, 0.5)",
                    activeCallBorderColor: "#4CAF50",
                    connectingCallBorderColor: "#FFC107",
                    inactiveCallBorderColor: "#BDBDBD",
                },
                showLanguageSelector: true,
                defaultLanguage: "tr-TR",
                availableLanguages: ["tr-TR", "en-US", "en-GB", "de-DE", "fr-FR", "es-ES"],
                hidePoweredByText: false,
                whitelistPages: ["*"],
                blacklistPages: [],
                allowedDomains: [],
                optOutSensitiveDataStorage: false,
                offsetTop: 0,
                offsetBottom: 20,
                offsetRight: 20,
                offsetLeft: 20,
            },
            languageOptions: [
                { id: "tr-TR", name: "Türkçe" },
                { id: "en-US", name: "Amerikan İngilizcesi" },
                { id: "en-GB", name: "İngiliz İngilizcesi" },
                { id: "en-AU", name: "Avustralya İngilizcesi" },
                { id: "en-IN", name: "Hint İngilizcesi" },
                { id: "en-NZ", name: "Yeni Zelanda İngilizcesi" },
                { id: "es-ES", name: "İspanyolca (İspanya)" },
                { id: "es-419", name: "İspanyolca (Latin Amerika)" },
                { id: "fr-FR", name: "Fransızca (Fransa)" },
                { id: "fr-CA", name: "Fransızca (Kanada)" },
                { id: "de-DE", name: "Almanca" },
                { id: "zh-CN", name: "Çince" },
                { id: "hi-IN", name: "Hintçe" },
                { id: "ja-JP", name: "Japonca" },
                { id: "pt-PT", name: "Portekizce (Portekiz)" },
                { id: "pt-BR", name: "Portekizce (Brezilya)" },
                { id: "ru-RU", name: "Rusça" },
                { id: "it-IT", name: "İtalyanca" },
                { id: "ko-KR", name: "Korece" },
                { id: "nl-NL", name: "Hollandaca" },
                { id: "pl-PL", name: "Lehçe" },
                { id: "vi-VN", name: "Vietnamca" },
                { id: "ro-RO", name: "Romence" },
                { id: "da-DK", name: "Danca" },
                { id: "fi-FI", name: "Fince" },
                { id: "el-GR", name: "Yunanca" },
                { id: "id-ID", name: "Endonezce" },
                { id: "no-NO", name: "Norveççe" },
                { id: "sk-SK", name: "Slovakça" },
                { id: "sv-SE", name: "İsveççe" },
                { id: "bg-BG", name: "Bulgarca" },
                { id: "hu-HU", name: "Macarca" },
                { id: "ca-ES", name: "Katalanca" },
                { id: "multi", name: "Çok Dilli" },
            ],
            showAdvancedColors: false,
            sections: {
                general: true,
                colors: false,
                language: false,
                pages: false,
                domains: false,
                code: false,
            },
        };
    },
    methods: {
        filterLanguageOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },

        async fetchWebAgentSettings() {
            if (!this.agent || !this.agent.agent_id) {
                console.log("Agent henüz yüklenmedi, web agent ayarları çekilemiyor");
                return;
            }

            this.isLoading = true;
            try {
                const settings = await VOICE_AGENT_API.webAgent.getSettings(this.agent.agent_id);
                this.webAgentSettings = settings;

                if (settings) {
                    // Form verilerini ayarla
                    this.formData = {
                        enabled: settings.enabled,
                        position: settings.position || "bottom-right",
                        buttonText: settings.buttonText || this.$t("voiceagent.voiceChat"),
                        icon: settings.icon || "phone",
                        colors: {
                            primaryColor: settings.colors?.primaryColor || "#3498db",
                            textColor: settings.colors?.textColor || "#ffffff",
                            backgroundColor: settings.colors?.backgroundColor || "#ffffff",
                            containerBackgroundColor: settings.colors?.containerBackgroundColor || "#ffffff",
                            containerBorderColor: settings.colors?.containerBorderColor || "#e1e1e1",
                            buttonBackgroundColor: settings.colors?.buttonBackgroundColor || "#000000",
                            buttonTextColor: settings.colors?.buttonTextColor || "#ffffff",
                            buttonHoverBackgroundColor: settings.colors?.buttonHoverBackgroundColor || "#333333",
                            iconBackgroundColor: settings.colors?.iconBackgroundColor || "#f0f0f0",
                            iconBorderColor: settings.colors?.iconBorderColor || "#d0d0d0",
                            languageSelectorBackgroundColor:
                                settings.colors?.languageSelectorBackgroundColor || "#ffffff",
                            languageSelectorTextColor: settings.colors?.languageSelectorTextColor || "#333333",
                            languageSelectorBorderColor:
                                settings.colors?.languageSelectorBorderColor || "rgba(0, 0, 0, 0.1)",
                            poweredByTextColor: settings.colors?.poweredByTextColor || "rgba(0, 0, 0, 0.5)",
                            activeCallBorderColor: settings.colors?.activeCallBorderColor || "#4CAF50",
                            connectingCallBorderColor: settings.colors?.connectingCallBorderColor || "#FFC107",
                            inactiveCallBorderColor: settings.colors?.inactiveCallBorderColor || "#BDBDBD",
                        },
                        showLanguageSelector:
                            settings.showLanguageSelector !== undefined ? settings.showLanguageSelector : true,
                        defaultLanguage: settings.defaultLanguage || "tr-TR",
                        availableLanguages: settings.availableLanguages || [
                            "tr-TR",
                            "en-US",
                            "en-GB",
                            "de-DE",
                            "fr-FR",
                            "es-ES",
                        ],
                        hidePoweredByText: settings.hidePoweredByText || false,
                        whitelistPages: settings.whitelistPages || ["*"],
                        blacklistPages: settings.blacklistPages || [],
                        allowedDomains: settings.allowedDomains || [],
                        optOutSensitiveDataStorage: settings.optOutSensitiveDataStorage || false,
                        offsetTop: settings.offsetTop !== undefined ? settings.offsetTop : 0,
                        offsetBottom: settings.offsetBottom !== undefined ? settings.offsetBottom : 20,
                        offsetRight: settings.offsetRight !== undefined ? settings.offsetRight : 20,
                        offsetLeft: settings.offsetLeft !== undefined ? settings.offsetLeft : 20,
                    };
                }
            } catch (error) {
                console.error("Web Agent ayarları alınırken hata:", error);
                this.$message.error(this.$t("voiceagent.webAgentSettingsLoadError"));
            } finally {
                this.isLoading = false;
            }
        },

        async createWebAgent() {
            this.isSaving = true;

            try {
                // Seçilen agent_id'yi kullanarak varsayılan ayarlarla oluştur
                const defaultSettings = {
                    selectedAgentId: this.agent.agent_id,
                    enabled: true,
                    position: "bottom-right",
                    buttonText: this.$t("voiceagent.voiceChat"),
                    icon: "phone",
                    showLanguageSelector: true,
                    defaultLanguage: this.agent.language || "tr-TR",
                };

                const settings = await VOICE_AGENT_API.webAgent.updateSettings(this.agent.agent_id, defaultSettings);

                this.webAgentSettings = settings;
                this.$message.success(this.$t("voiceagent.webAgentCreated"));

                // Form verilerini güncelle
                await this.fetchWebAgentSettings();
            } catch (error) {
                console.error("Web Agent oluşturulurken hata:", error);
                this.$message.error(this.$t("voiceagent.webAgentCreateError"));
            } finally {
                this.isSaving = false;
            }
        },

        async saveSettings() {
            this.isSaving = true;

            try {
                const updatedSettings = await VOICE_AGENT_API.webAgent.updateSettings(
                    this.agent.agent_id,
                    this.formData
                );

                this.webAgentSettings = updatedSettings;
                this.$message.success(this.$t("voiceagent.webAgentSettingsSaved"));

                // Yayın kodunu güncelle
                await this.getPublishCode();
            } catch (error) {
                console.error("Web Agent ayarları kaydedilirken hata:", error);
                this.$message.error(this.$t("voiceagent.webAgentSettingsSaveError"));
            } finally {
                this.isSaving = false;
            }
        },

        async getPublishCode() {
            try {
                // Kullanıcının site ID'sini header'dan veya bir yerden alıyoruz
                this.siteId = this.$store?.state?.site?.siteDetail?._id || this.agent.site_id;
                this.timestamp = Math.floor(Date.now() / 1000);

                if (!this.siteId) {
                    console.error("Site ID bulunamadı");
                    return;
                }

                // Kodu da alıp saklayalım, mevcut kopyalama fonksiyonu için
                const response = await VOICE_AGENT_API.webAgent.getPublishCode(this.siteId, this.agent.agent_id);
                this.publishCode = response.scriptCode || "";
            } catch (error) {
                console.error("Yayın kodu alınırken hata:", error);
            }
        },

        copyCode() {
            // Direk DOM'dan kodu alıp kopyalayalım
            const codeElement = document.querySelector(".code-block code");
            if (!codeElement) return;

            // HTML özel karakterlerini kullanarak script tag
            const scriptCode =
                '<script src="' +
                this.voiceAgentUrl +
                "/setup.js?t=" +
                this.timestamp +
                '" type="text/javascript" async defer id="supsis-ai-web-voice-agent" site-id="' +
                this.siteId +
                '" agent-id="' +
                this.agent.agent_id +
                '"><\/script>';

            navigator.clipboard
                .writeText(scriptCode)
                .then(() => {
                    this.$message.success(this.$t("voiceagent.codeCopied"));
                })
                .catch((err) => {
                    console.error("Kopyalama hatası:", err);
                    this.$message.error(this.$t("voiceagent.codeCopyError"));
                });
        },

        toggleSection(section) {
            this.sections[section] = !this.sections[section];
        },

        isSectionOpen(section) {
            return this.sections[section];
        },
    },
    watch: {
        agent: {
            immediate: true,
            handler(newAgent) {
                if (newAgent && newAgent.agent_id) {
                    this.fetchWebAgentSettings();
                }
            },
        },
    },
};
</script>

<style scoped lang="scss">
.web-agent-tab {
    padding: 20px 0;

    .web-agent-tab-layout {
        display: flex;
        flex-direction: column;

        .no-settings-container {
            display: flex;
            flex-direction: column;
            align-items: center;

            .info-panel {
                max-width: 800px;
                padding: 30px;
                border-radius: 8px;
                background-color: #f9f9f9;
                text-align: center;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

                h3 {
                    font-size: 24px;
                    margin-bottom: 20px;
                    color: #22272d;
                }

                p {
                    font-size: 16px;
                    color: #444;
                    margin-bottom: 30px;
                    line-height: 1.6;
                }

                .features {
                    text-align: left;
                    margin: 30px 0;
                    background-color: #fff;
                    padding: 20px;
                    border-radius: 6px;

                    h4 {
                        margin-bottom: 15px;
                        color: #22272d;
                    }

                    ul {
                        padding-left: 10px;

                        li {
                            list-style: none;
                            margin-bottom: 12px;
                            display: flex;
                            align-items: center;

                            .material-icons {
                                color: #52c41a;
                                margin-right: 8px;
                            }
                        }
                    }
                }
            }
        }

        .settings-container {
            .settings-layout {
                display: flex;
                position: relative;

                .settings-form {
                    flex: 1;
                    width: calc(100% - 340px); /* Preview genişliği + boşluk */
                    max-height: calc(100vh - 180px);
                    overflow-y: auto;
                    padding-right: 40px; /* Scroll çubuğu için alan bırakma */

                    /* ScrollBar stillerini güzelleştirelim */
                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        background: #f0f0f0;
                        border-radius: 3px;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: #d0d0d0;
                        border-radius: 3px;
                    }

                    &::-webkit-scrollbar-thumb:hover {
                        background: #c0c0c0;
                    }
                }

                .settings-preview-container {
                    width: 320px; /* Sabit genişlik + iç padding */
                    position: relative;
                    flex-shrink: 0; /* Genişliğin değişmemesi için */
                }

                .settings-preview {
                    position: sticky;
                    top: 20px;
                    width: 100%;
                    height: auto;
                    max-height: calc(100vh - 180px);
                    padding: 15px;
                    background-color: #fff;
                    border-radius: 8px;
                    border: 1px solid #f0f0f0;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

                    /* Preview başlığını sabitleyelim */
                    h4 {
                        position: sticky;
                        top: 0;
                        background-color: #fff;
                        padding-bottom: 10px;
                        margin-bottom: 15px;
                        border-bottom: 1px solid #f0f0f0;
                        z-index: 1;
                    }
                }
            }

            .settings-section {
                margin-bottom: 30px;
                padding: 20px;
                background: #f9f9f9;
                border-radius: 6px;

                .section-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;
                    padding: 10px 0;
                    transition: all 0.2s ease;

                    &:hover {
                        background-color: rgba(34, 39, 45, 0.03);
                    }

                    .section-title {
                        display: flex;
                        align-items: center;

                        .material-icons {
                            margin-right: 8px;
                            color: #22272d;
                        }

                        h3 {
                            margin: 0;
                            padding: 0;
                            color: #22272d;
                            font-size: 18px;
                        }
                    }

                    .toggle-icon {
                        transition: transform 0.3s ease;
                        color: #22272d;
                        transform: rotate(0deg);
                    }
                }

                .section-header.open {
                    .toggle-icon {
                        transform: rotate(180deg);
                    }
                }

                .section-content {
                    margin-top: 10px;
                }

                .help-text {
                    font-size: 12px;
                    color: #999;
                    margin-top: 5px;
                }

                .code-block {
                    position: relative;
                    margin-top: 15px;

                    pre {
                        background-color: #f5f5f5;
                        padding: 15px;
                        border-radius: 4px;
                        overflow-x: auto;
                        white-space: pre-wrap;
                        word-wrap: break-word;
                        font-family: Consolas, Monaco, "Andale Mono", monospace;
                        font-size: 14px;
                        line-height: 1.5;
                        border: 1px solid #e8e8e8;
                    }

                    code {
                        color: #333;
                    }

                    .copy-btn {
                        position: absolute;
                        top: 10px;
                        right: 10px;
                    }
                }
            }

            .form-actions {
                display: flex;
                justify-content: flex-end;
                margin-top: 20px;
                margin-bottom: 30px; /* Alt tarafa biraz boşluk */
            }
        }
    }

    /* Responsive davranış */
    @media (max-width: 1200px) {
        .settings-container .settings-layout {
            flex-direction: column;

            .settings-form {
                width: 100%;
                padding-right: 0;
                max-height: none;
                overflow-y: visible;
            }

            .settings-preview-container {
                width: 100%;
                margin-top: 30px;

                .settings-preview {
                    position: relative;
                    top: 0;
                    max-height: 500px;
                }
            }
        }
    }
}
</style>
